/* PDP description excerpt (above the earn-points widget, not the
   Description tab): 3-line clamp (desktop) / 5-line (mobile) with a Read
   more/less toggle. See sections/main-product.liquid's 'description' block
   case. */
(function () {
  var STRINGS = window.descReadmoreStrings || {};

  function checkOverflow(clamp, btn) {
    var isOverflowing = clamp.scrollHeight - clamp.clientHeight > 2;
    btn.hidden = !isOverflowing && !clamp.classList.contains('is--expanded');
  }

  function init() {
    var clamp = document.querySelector('[data-desc-clamp]');
    var btn = document.querySelector('[data-desc-readmore]');
    if (!clamp || !btn) return;

    var label = btn.querySelector('[data-desc-readmore-label]');

    function recheck() {
      if (!clamp.classList.contains('is--expanded')) checkOverflow(clamp, btn);
    }

    // ResizeObserver fires whenever the clamp's box size actually changes -
    // becoming visible (tab switch/accordion open), font load, content
    // change, viewport resize - covers every case a manual event listener
    // would have to be wired up for individually.
    if (window.ResizeObserver) {
      new ResizeObserver(recheck).observe(clamp);
    } else {
      recheck();
      window.addEventListener('resize', recheck);
      var tabContent = clamp.closest('[data-t4s-tab-content]');
      var tabItem = tabContent && document.querySelector('[data-t4s-tab-item][href="#' + tabContent.id + '"]');
      if (tabItem) tabItem.addEventListener('click', function () { setTimeout(recheck, 50); });
    }

    btn.addEventListener('click', function () {
      var expanded = clamp.classList.toggle('is--expanded');
      btn.classList.toggle('is--expanded', expanded);
      if (label) label.textContent = expanded ? (STRINGS.readLess || 'Read less') : (STRINGS.readMore || 'Read more');
      if (!expanded) checkOverflow(clamp, btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
